import { z } from 'zod';

/**
 * Everything here ends up in the browser bundle. Never put a secret in a `VITE_*` variable.
 * Vite inlines these at build time, so each environment needs its own build.
 */
const envSchema = z.object({
  VITE_APP_NAME: z.string().min(1).default('Club29'),
  VITE_API_BASE_URL: z.url({ error: 'VITE_API_BASE_URL must be an absolute URL' }),
  VITE_API_TIMEOUT_MS: z.coerce.number().int().positive().default(15_000),
});

const result = envSchema.safeParse(import.meta.env);

if (!result.success) {
  // Fail loudly at startup rather than with a confusing runtime error later.
  throw new Error(`Invalid frontend environment configuration:\n${z.prettifyError(result.error)}`);
}

export const env = result.data;
